module.exports = __webpack_public_path__ + "img/teacher.ee22f45a.svg";